var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"van-tabs-content item6"},[_c('img',{staticClass:"item6_bg",attrs:{"src":require("@/assets/img/item6_bg.png"),"alt":""}}),_vm._l((_vm.homeContent),function(item,index){return _c('div',{key:index,staticClass:"context-box"},[_c('img',{attrs:{"src":item.ImgSrc,"alt":""}}),_vm._v(_vm._s(_vm.$t(item.label))+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }